<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <!-- Creator: CorelDRAW 2020 (64 Bit) -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="313px"
    height="450px"
    version="1.1"
    style="
      shape-rendering: geometricPrecision;
      text-rendering: geometricPrecision;
      image-rendering: optimizeQuality;
      fill-rule: evenodd;
      clip-rule: evenodd;
    "
    viewBox="0 0 313 449.66"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
  >
    <g id="Layer_x0020_2">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <g id="_2264820921664">
        <path
          class="fil0"
          d="M241.4 176.23c6.92,-0.23 46.13,-0.79 50.2,0.32 0.73,4.07 0.26,169.51 0.21,179.45 -0.04,7.37 1,64.41 -0.68,66.05 -0.54,6.74 -8.71,5.91 -15.6,5.92l-242.33 0.01c-8.45,0.02 -10.28,-2.93 -10.3,-11.16l0 -288.5c0.01,-6.25 -1.46,-16.22 2.92,-19.27 3.67,-2.56 14.99,-1.6 20.25,-1.6l65.79 -0.09c1.09,-4.33 0.15,-16.26 0.44,-21.69 -14.42,-0.41 -29.49,-0.05 -43.97,-0.01 -14.23,0.03 -29.51,-0.57 -43.57,0.23 -9.88,0.49 -18.49,9.11 -21.7,15.76 -4.4,9.13 -2.75,23.67 -2.78,35.08l0 208.88c0,25.34 -0.28,50.85 0,76.18 0.13,11.4 6.97,19.75 14,23.87 9.25,5.41 22.55,3.75 34.27,3.79 75.8,0.27 152.16,-0.39 227.96,0 5.96,0.03 12.11,0.43 17.42,-1.34 4.6,-1.52 9.53,-5.01 11.69,-7.63 8.37,-10.14 7.3,-15.3 7.3,-30.58l0.01 -227.67c0.01,-6.98 0.74,-11.33 -2.8,-16.31l-22.89 -24.58c-2.25,-2 -2.92,-2.55 -4.74,-4.65l-23.2 -24.29c-2.03,-1.91 -3.3,-2.95 -5.11,-4.77 -3.23,-3.26 -6.04,-6.26 -9.25,-9.55 -2.71,-2.77 -6.47,-7.38 -9.87,-9.42 -8.05,-4.83 -23.94,-3.36 -34.54,-3.11 -0.64,2.46 -0.55,18.82 -0.21,21.91l30.19 0c-0.29,13.19 -0.04,26.5 -0.06,39.66 -0.02,9.81 -3.04,27.96 10.95,29.11z"
        />
        <path
          class="fil0"
          d="M92.82 67.93c-0.65,-3.32 0.92,-3.65 2.52,-5.35 3,-3.18 4.64,-5.69 7.88,-8.44l19.56 -20.99c2.52,-3.07 5.37,-5.2 7.93,-8.39l15.72 -16.92c1.46,-1.67 2.7,-2.36 4.22,-4.18 6.2,-7.45 6.12,-2.19 12.89,3.94l50.65 55.18c1.59,1.7 2.82,1.95 2.24,5.17 -4.14,1.37 -26.74,0.32 -33.51,0.55 0.71,33.42 -0.27,65.49 -0.06,99.5 0.04,7.74 -2.59,7.27 -9.7,7.28l-34.12 0.03c-7.37,0.05 -9.44,-0.04 -9.33,-7.82 0.46,-33.78 -0.32,-64.98 0.03,-98.96 -7.42,-0.3 -32.46,0.87 -36.92,-0.6z"
        />
        <path
          class="fil0"
          d="M77.43 251.48c3.56,0.16 12.15,2.04 16.56,2.71l25.59 4.08 10.61 9.16c1,0.89 1.35,1.6 2.41,2.54l33.4 30.37c2.65,2.21 8.16,6.98 9.96,9.37l76.22 -0.18 -0.18 -58.2 -174.57 0.15z"
        />
        <path
          class="fil0"
          d="M60.88 251.57c-0.29,6.38 -0.57,55.39 0.31,58.13 18.15,1.35 36.44,3.31 54.59,4.12 19.45,0.88 39.56,-0.24 59.1,0.22 -1.89,-3.11 -3.93,-3.59 -5.97,-5.72 -2.38,-2.49 -3.26,-3.22 -5.62,-5.27l-11.38 -10.36c-2.39,-2.13 -1.91,-2.33 -5.87,-5.51 -2.07,-1.66 -3.54,-3.52 -5.62,-5.26 -4.44,-3.68 -21.17,-19.98 -23.31,-20.67 -3.27,-1.04 -31.43,-5.47 -37.47,-6.56 -5.97,-1.08 -12.69,-2.51 -18.76,-3.12z"
        />
        <path
          class="fil0"
          d="M190.04 374.68l0.23 -56.66c-3.66,-1.06 -28.09,-0.31 -33.92,-0.35 -11.06,-0.06 -22.77,0.43 -33.73,0.01l0.02 57.03 67.4 -0.03z"
        />
        <path
          class="fil0"
          d="M123.28 247.21c14.09,0.52 52.03,0.31 66.16,-0.06l0.06 -50.06 -66.22 0.1 0.02 39.63 -0.02 10.39z"
        />
        <path
          class="fil1"
          d="M190.04 374.68l-67.4 0.03 -0.02 -57.03c-0.7,1.43 -0.5,1.9 -0.51,3.7 -0.05,9.74 -0.49,51.05 0.39,53.6 3.18,0.52 28.4,0.17 33.85,0.17l32.17 0.01c1.98,-0.2 1.01,-0.2 1.52,-0.48z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
